var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_6950)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5612 36.9388L51.0613 26.4388C50.9218 26.2995 50.7564 26.1891 50.5743 26.1138C50.3922 26.0385 50.197 25.9998 50 26H27.5C27.1022 26 26.7206 26.158 26.4393 26.4393C26.158 26.7206 26 27.1022 26 27.5V50C26.0002 50.3936 26.1551 50.7714 26.4312 51.0519L36.9313 61.5519C37.0708 61.6937 37.2371 61.8064 37.4206 61.8833C37.6041 61.9603 37.801 61.9999 38 62H60.5C60.8978 62 61.2794 61.842 61.5607 61.5607C61.842 61.2794 62 60.8978 62 60.5V38C62.0002 37.803 61.9615 37.6078 61.8862 37.4257C61.8109 37.2436 61.7005 37.0782 61.5612 36.9388ZM51.5 31.1206L56.8794 36.5H51.5V31.1206ZM36.5 56.8794L31.1206 51.5H36.5V56.8794ZM36.5 48.5H29V31.1206L36.5 38.6206V48.5ZM31.1206 29H48.5V36.5H38.6206L31.1206 29ZM48.5 39.5V48.5H39.5V39.5H48.5ZM39.5 59V51.5H49.3794L56.8794 59H39.5ZM59 56.8794L51.5 49.3794V39.5H59V56.8794Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_6950",
    x1: 0,
    y1: 45,
    x2: 90,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH5);
export default __webpack_public_path__ + "static/media/h-5.d76dab94013368d87452b00897b76769.svg";
export { ForwardRef as ReactComponent };